import { useEffect, useState } from 'react';

export function useMarketTradeHistory({
	market,
	isExpanded,
	trades,
	handleGetTradesByMarket,
	skip = false,
}: {
	market: any;
	isExpanded: boolean;
	trades: any[] | undefined;
	handleGetTradesByMarket?: (marketId: string) => Promise<any[]>;
	skip?: boolean;
}) {
	const [tradeHistory, setTradeHistory] = useState<any[]>([]);

	const buildTradeHistory = (tradesList: any[]) => {
		if (!tradesList?.length) {
			setTradeHistory([]);
			return;
		}

		const sorted = [...tradesList].sort(
			(a, b) => (new Date(a.created_date) as any) - (new Date(b.created_date) as any)
		);

		let dataPoints: any[] = sorted.map((trade) => ({
			timestamp: new Date(trade.created_date).getTime(),
			value: trade.entry_price,
			position: trade.position,
			role: trade.user_role,
		}));

		const firstTs: any = new Date(sorted[0].created_date);

		const startPoint = {
			timestamp: firstTs - 60_000,
			value: market.initial_value,
			label: 'Start',
		};

		dataPoints = [startPoint, ...dataPoints];

		const adjustedDataPoints =
			dataPoints.length === 2
				? [
						...dataPoints,
						{
							...dataPoints[1],
							timestamp: dataPoints[1].timestamp + 1,
						},
					]
				: dataPoints;

		setTradeHistory(adjustedDataPoints);
	};

	useEffect(() => {
		if (!isExpanded || skip) {
			setTradeHistory([]);
			return;
		}

		let isCanceled = false;

		const fetchTrades = async () => {
			const tradesData = trades ?? (await handleGetTradesByMarket?.(market.id));

			if (!isCanceled) {
				buildTradeHistory(tradesData ?? []);
			}
		};

		fetchTrades();

		return () => {
			isCanceled = true;
		};
	}, [isExpanded, market.id, trades, skip]);

	return tradeHistory;
}
